// ZEO-Autopilot (03.11.2026): Filter „Autopilot-Befunde“ der Aufgabenseite. Nur Lesen; Klick oeffnet die Aufgabe (dort Karte + Vorschau).
import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { betreuungAPI } from '@/api/betreuungAPI';
import { EINSTUFUNG, ENTSCHEIDUNG, datum, dublettenText, erledigungText } from '@/lib/autopilotBefund';
import AutopilotNachtUebersicht from '@/components/AutopilotNachtUebersicht';

export default function AutopilotBefundListe({ klientId, onOpen }) {
  const [einstufung, setEinstufung] = useState('');
  const [daten, setDaten] = useState({ art: 'laden' });
  useEffect(() => {
    let aktiv = true;
    setDaten({ art: 'laden' });
    betreuungAPI.autopilotBefunde({ klient_id: klientId || undefined, einstufung: einstufung || undefined })
      .then((r) => { if (aktiv) setDaten(r === null ? { art: 'aus' } : { art: 'ok', ...r }); })
      .catch(() => { if (aktiv) setDaten({ art: 'fehler' }); });
    return () => { aktiv = false; };
  }, [klientId, einstufung]);
  return (
    <div className="space-y-3" data-testid="autopilot-liste">
      {!klientId && <AutopilotNachtUebersicht onOpen={onOpen} />}
      <div className="flex items-center gap-2 text-sm">
        <span className="text-slate-500">Einstufung:</span>
        <select className="border rounded px-2 py-1" value={einstufung} onChange={(e) => setEinstufung(e.target.value)} data-testid="autopilot-einstufung">
          <option value="">alle</option>
          {Object.entries(EINSTUFUNG).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
        {daten.art === 'ok' && <span className="text-slate-500" data-testid="autopilot-anzahl">{daten.anzahl} Befund(e) – nur Vorschläge, nichts ausgeführt</span>}
      </div>
      {daten.art === 'laden' && <div className="flex justify-center py-8"><RefreshCw className="w-5 h-5 animate-spin text-slate-400" /></div>}
      {daten.art === 'aus' && <p className="text-sm text-slate-500" data-testid="autopilot-aus">Autopilot-Befundspeicher ist nicht eingerichtet.</p>}
      {daten.art === 'fehler' && <p className="text-sm text-red-600">Befunde konnten nicht geladen werden.</p>}
      {daten.art === 'ok' && daten.anzahl === 0 && <p className="text-sm text-slate-500">Keine Befunde.</p>}
      {daten.art === 'ok' && daten.befunde.map((b) => (
        <button key={b.aufgabe_id} className="w-full text-left bg-white border rounded-xl p-3 hover:border-blue-300" onClick={() => onOpen(b.aufgabe_id)}
          data-testid={`autopilot-befund-${b.aufgabe_id}`}>
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs px-2 py-0.5 rounded bg-slate-100">{(EINSTUFUNG[b.einstufung] || { label: b.einstufung }).label}</span>
            <span className="font-medium">{b.aufgabe?.titel || b.aufgabe_id}</span>
            <span className="text-slate-500 text-sm">{b.aufgabe?.klient_name || '—'}</span>
          </div>
          <div className="text-xs text-slate-600 mt-1">
            Stand {b.aufgabe?.status || '—'} · Frist {b.frist ? datum(b.frist) : '—'} · Priorität {b.aufgabe?.prioritaet || '—'} ·
            Entscheidung: {ENTSCHEIDUNG[b.empfehlung] || b.empfehlung}
          </div>
          <div className="text-xs text-slate-500">{erledigungText(b)} · {dublettenText(b)}{(b.fehlende_angaben || []).length ? ` · Fehlt: ${b.fehlende_angaben.join(', ')}` : ''}</div>
        </button>))}
    </div>
  );
}
